import * as React from 'react';
import styled from 'styled-components';

import { scrollBarStylesGeneral } from '@doltech/utils/lib/css-style';
import { IconSystemV2SClose } from '@doltech/icons/SystemV2/IconSystemV2SClose';

import { colorsV2 } from '../../figma/colors-v2';
import { ResponsiveTypography } from '../../figma/Typography/v3/ResponsiveTypography';
import { ButtonIconPrimaryGeneral } from '../../figma/Button/ButtonIconPrimaryGeneral/ButtonIconPrimaryGeneral';
import { MotionDrawer } from '../../figma/MotionDrawer/MotionDrawer';

const ScrollContent = styled.div`
  overflow-y: auto;
  ${scrollBarStylesGeneral()}
`;

const Header = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  column-gap: 12px;

  padding: 16px;
  border-bottom: 1px solid ${colorsV2.neutral40};
`;

const Container = styled.div`
  display: grid;
  grid-template-rows: auto minmax(0, 1fr);

  max-height: 80vh;

  background-color: ${colorsV2.white100};
  border-radius: 24px 24px 0 0;
`;

interface EditorDrawerLayoutProps {
  title?: string;
  children?: React.ReactNode;
  onClose?: (event: any) => void;

  visible?: boolean;
}

export const EditorDrawerLayout = (props: EditorDrawerLayoutProps) => {
  const { title, children, onClose, visible = false } = props;

  return (
    <MotionDrawer placement="bottom" onClose={onClose} visible={visible} transparent>
      <Container className="editor-drawer-layout">
        <Header className="toc-header">
          <ResponsiveTypography.Paragraph variant="semi-bold/20-32" color="neutral180">
            {title}
          </ResponsiveTypography.Paragraph>
          <ButtonIconPrimaryGeneral
            className="action-close"
            type="white"
            buttonStyle="outline"
            icon={<IconSystemV2SClose />}
            onClick={onClose}
          />
        </Header>
        <ScrollContent>
          {children}
        </ScrollContent>
      </Container>
    </MotionDrawer>
  );
};
